<template>
  <div class="p-6 block-page">
    <pack-result-details
      :isPromptActive="showResultDetailsPrompt"
      :infos="selectedResult"
      @closePrompt="toogleShowResultDetailsPrompt"
    />
    <div class="presentation">
      <h3>Mes résultats</h3>
      <h5 class="mt-2">
        <span class="yello">Y’ello</span> Robert, vous avez complété
        <span class="global-percent color-aa font-bold"
          >{{ resultKpi.percent_followed_pack }} %</span
        >
        de vos formations.
      </h5>
    </div>

    <div class="stats_kpi mt-10">
      <div class="stats_gle">
        <div class="avg">
          <h6 class="font-bold">Moyenne Générale</h6>
          <h1 class="avg_value font-bold">{{ resultKpi.gle_avg }} %</h1>
        </div>
        <div class="graph pt-8">
          <div id="chart" v-if="loading == false">
            <apexchart
              type="bar"
              height="200"
              :options="chartOptions"
              :series="series"
            ></apexchart>
          </div>
        </div>
        <div class="other"></div>
      </div>
      <div class="stats_top_work" :style="topWorkCssprops">
        <div>
          <h6 class="text-white ml-4">Sans fautes</h6>
          <h1 class="text-white font-bold ml-4">
            {{ resultKpi.perfect_count }}
          </h1>
        </div>
      </div>
    </div>
    <div class="pack_results">
      <div class="form_section">
        <div class="vx-row mt-2 ml-1">
          <p class="mt-2 text-black">Ordonné par</p>
          <div class="w-1/3 ml-4">
            <v-select
              class="w-full"
              label="name"
              v-model="selectedFilter"
              :reduce="(filter) => filter.id"
              :options="filters"
            ></v-select>
          </div>
          <div class="w-1/4 ml-2">
            <vs-input
              @keypress.enter="getPackTrainingsResults()"
              autocomplete="off"
              placeholder="Rechercher"
              name="search"
              class="w-full"
              v-model="search"
            />
          </div>
        </div>
      </div>
      <div class="results-section">
        <div
          @click="(selectedResult = item), toogleShowResultDetailsPrompt(true)"
          class="result-item"
          v-for="(item, index) in results"
          :key="index"
        >
          <div class="result-item-element-left">
            <h5 class="font-bold">{{ item.title }}</h5>
            <span>Composé le {{ convertDate(item.date) }}</span>
          </div>
          <div
            class="result-item-element-right"
            :style="item.avg == 100 ? perfectScoreCss : perfectScoreCssDefault"
          >
            <div class="certification">
              <span class="font-bold text-black mr-4">{{ item.avg }} %</span>
              <svg
                v-if="item.avg == 100"
                width="15"
                height="15"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16 0C15.1 0 14 1 14 2H6C6 1 4.9 0 4 0H0V9C0 10 1 11 2 11H4.2C4.6 13 5.9 14.7 9 15V17.08C6 17.54 6 20 6 20H14C14 20 14 17.54 11 17.08V15C14.1 14.7 15.4 13 15.8 11H18C19 11 20 10 20 9V0H16ZM4 9H2V2H4V9ZM18 9H16V2H18V9Z"
                  fill="black"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var self = null;
import moment from "moment";
import { _buildQuery } from "../../../helpers/buildquery";
import packResultDetails from "./components/packResultDetails.vue";

export default {
  name: "Otd2PackResults",
  components: {
    packResultDetails,
  },
  data() {
    return {
      showResultDetailsPrompt: false,
      selectedFilter: "1",
      filters: [
        { id: "1", name: "Dernière composition" },
        { id: "2", name: "Ordre alphabétique" },
      ],
      search: "",
      selectedResult: {},
      resultKpi: {
        percent_followed_pack: 0,
        gle_avg: 0,
        perfect_count: 0,
      },
      page: 1,
      last_page: null,
      results: [],
      perfectScoreCssDefault: {},
      perfectScoreCss: {
        background: `linear-gradient(195.83deg, #ffcc00 -0.13%, rgba(255, 204, 0, 0) 56.67%)`,
      },
      loading: false,
      series: [
        {
          name: "",
          data: [],
        },
      ],
      chartOptions: {
        legend: {
          show: false,
        },
        colors: ["#3B3B3B", "#FFFFFF"],
        chart: {
          type: "bar",
          height: 350,
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            borderRadius: 10,
            horizontal: false,
            columnWidth: "55%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: false,
        },
        // stroke: {
        //   show: true,
        //   width: 12.5,
        //   colors: ["transparent"],
        // },
        xaxis: {
          categories: [],
          labels: {
            formatter: function (value) {
              return "";
            },
          },
        },
        yaxis: {
          categories: [],
          labels: {
            formatter: function (value) {
              return "";
            },
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          custom: function ({ series, seriesIndex, dataPointIndex, w }) {
            // console.log(dataPointIndex, self.chartOptions.xaxis.categories[dataPointIndex]);
            return (
              '<div class="arrow_box">' +
              "<span>" +
              self.chartOptions.xaxis.categories[dataPointIndex] +
              " : " +
              series[seriesIndex][dataPointIndex] +
              " %</span>" +
              "</div>"
            );
          },
        },
      },
      topWorkCssprops: {
        "background-image": "",
        "background-size": "",
        "background-repeat": "",
        "background-attachment": "",
        "background-position": "",
      },
    };
  },
  watch: {
    selectedFilter: function () {
      this.getPackTrainingsResults();
    },
    search(value) {
      if (value == "") {
        this.getPackTrainingsResults();
      }
    },
  },
  mounted() {
    self = this;
    this.topWorkCssprops[
      "background-image"
    ] = `url(${require("@/assets/images/agent-academy/topWork.png")}), linear-gradient(180deg, #a48508 0%, #000000 100%)`;
    this.topWorkCssprops["background-size"] = `auto 100% !important`;
    this.topWorkCssprops["background-repeat"] = `no-repeat`;
    this.topWorkCssprops["background-position"] = `right`;

    this.getPackTrainingsResults();
    this.getPackTrainingsResultsKpi();
  },

  methods: {
    convertDate(date) {
      moment.locale("fr");
      return moment(date).format("DD MMMM YYYY");
    },
    toogleShowResultDetailsPrompt(val = false) {
      this.showResultDetailsPrompt = val;
    },

    getPercentWidth(chartWidth, series, columnWidth) {
      const percentWidth = Math.round(
        (columnWidth / (chartWidth / series)) * 100
      );
      console.log(percentWidth);
      return `${percentWidth}%`;
    },
    async getPackTrainingsResults() {
      this.$vs.loading();
      let payload = {
        order: this.selectedFilter ? this.selectedFilter : "",
        search: this.search,
        limit: 10,
      };
      try {
        let response = await this.$http.get(
          "trainings-pack/get-results" + _buildQuery(payload)
        );
        if (response.data) {
          this.results = response.data;
          // this.search = "";
          this.$vs.loading.close();
        }
      } catch (error) {
        console.log(error);
        this.$vs.notify({
          title: "Erreur",
          text: "Veuillez contacter l'administrateur",
          color: "danger",
          position: "top-right",
        });
        this.$vs.loading.close();
      }
    },
    async getPackTrainingsResultsKpi() {
      try {
        this.loading = true;
        let response = await this.$http.get("trainings-pack/get-results-kpi");
        if (response.data) {
          this.resultKpi.percent_followed_pack =
            response.data.percent_followed_pack;
          this.resultKpi.gle_avg = response.data.gle_avg;
          this.resultKpi.perfect_count = response.data.perfect_count;
          this.series[0] = response.data.last10Perf.values;
          this.chartOptions.xaxis.categories =
            response.data.last10Perf.categories;

          this.chartOptions.plotOptions.bar.columnWidth = this.getPercentWidth(
            300,
            response.data.last10Perf.values.data.length,
            14
          );
          this.loading = false;
        }
      } catch (error) {
        console.log(error);
        this.loading = false;
        this.$vs.notify({
          title: "Erreur",
          text: "Veuillez contacter l'administrateur",
          color: "danger",
          position: "top-right",
        });
        this.$vs.loading.close();
      }
    },
  },
};
</script>

<style lang="scss" >
.presentation {
  .global-percent {
    font-size: 3.5vh;
  }
}
.color-aa {
  text-decoration: underline !important;
}
.block-page {
  width: 100%;
}

.stats_kpi {
  height: auto;
  display: flex;
  flex-direction: row;
}

.stats_gle {
  width: 75%;
  height: 30vh;
  margin: 5px;
  padding: 5px;
  background: linear-gradient(180deg, #fffef9 0%, #ffffff 0.01%, #ffcc00 100%);
  border-radius: 6px;
  display: flex;
  flex-direction: row;
  align-items: center;

  .avg {
    width: 40%;
    text-align: center;
    h6 {
      margin-top: 20px;
    }
    .avg_value {
      font-size: 6.5vh;
    }
  }

  .graph {
    width: 50%;
    text-align: right;
  }
}
.stats_top_work {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 25%;
  height: 30vh;
  margin: 5px;
  padding: 5px;
  border-radius: 6px;
  p {
    font-weight: 500;
    font-size: 60px;
  }
  h1 {
    font-size: 6.5vh;
  }
}

//graph arraow
.arrow_box {
  position: relative;
  background: #555;
  border: 1px solid #000000;
}

#chart .apexcharts-tooltip {
  color: #fff;
  transform: translateX(10px) translateY(10px);
  overflow: visible !important;
  white-space: normal !important;
}

#chart .apexcharts-tooltip span {
  display: inline-block;
}

.results-section {
  margin-top: 30px;
  display: flex;
  flex-direction: column;

  .result-item {
    // border: 1px solid black;
    // width: 100%;
    height: 10vh;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    // padding: 0px 20px 0px 20px;
    margin: 5px;

    background: #ffffff;
    box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
    border-radius: 10px;
    cursor: pointer;

    .result-item-element-left {
      width: 80%;
      margin-left: 30px;
      border-radius: 10px;
    }
    .result-item-element-right {
      width: 20%;
      height: 100%;
      border-radius: 10px;
      padding-right: 30px;
      padding-top: 30px;
      text-align: right;

      .certification {
        display: inline-block;
        span {
          font-size: 18px;
        }
      }
    }
  }
}
</style>